module.exports = __webpack_public_path__ + "img/gongshang.ad47cb58.png";